declare namespace $ {

	type $mol_button_major__sub_shm_hitalama_map_widget_view_autoview_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_view_autoview_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_view_autoview['run_click'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_grid__minimal_height_shm_hitalama_map_widget_view_autoview_3 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_grid['minimal_height'] >
	>
	type $mol_grid__records_shm_hitalama_map_widget_view_autoview_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_view_autoview['table_rows'] >
		,
		ReturnType< $mol_grid['records'] >
	>
	type $mol_grid__col_ids_shm_hitalama_map_widget_view_autoview_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_view_autoview['table_col_ids'] >
		,
		ReturnType< $mol_grid['col_ids'] >
	>
	type $mol_grid__col_head_content_shm_hitalama_map_widget_view_autoview_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_view_autoview['table_col_head_content'] >
		,
		ReturnType< $mol_grid['col_head_content'] >
	>
	type $mol_dump_value__value_shm_hitalama_map_widget_view_autoview_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_view_autoview['result'] >
		,
		ReturnType< $mol_dump_value['value'] >
	>
	type $mol_dump_value__style_shm_hitalama_map_widget_view_autoview_8 = $mol_type_enforce<
		({ 
			'--shm_hitalama_map_widget_float_autoview_font_size': ReturnType< $shm_hitalama_map_widget_view_autoview['font_size_px'] >,
		})  & ReturnType< $mol_dump_value['style'] >
		,
		ReturnType< $mol_dump_value['style'] >
	>
	export class $shm_hitalama_map_widget_view_autoview extends $mol_view {
		Run_icon( ): $mol_icon_play
		run_click( next?: any ): any
		Run( ): $mol_button_major
		table_rows( ): Record<string, any>
		table_col_ids( ): readonly(any)[]
		table_col_head_content( id: any): readonly(any)[]
		Table( ): $mol_grid
		Dom_wrapper( ): any
		autoview_content( ): readonly(any)[]
		result( ): any
		font_size_px( ): string
		code_widget( ): $shm_hitalama_map_widget
		Map_page( ): $shm_hitalama_map_page
		sub( ): readonly(any)[]
		Dump( ): $mol_dump_value
	}
	
}

//# sourceMappingURL=autoview.view.tree.d.ts.map